import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/src/popokgamingv2-prd/app/[lang]/(web)/badalyans-ai/badalyansAi.tsx");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/app/[lang]/(web)/badalyans-ai/styles.scss");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/ar.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/en.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/es.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/fr.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/hi.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/pt.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/ru.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/zh.png");
